export const dateFormat = 'DD/MM/YYYY'

export const formatDate = (date: string | undefined) =>
	date ? new Date(date).toLocaleString('en-GB') : ''

export const getDateGeneralFormat = (date: string) => {
	const typedDate = new Date(date)
	const day = typedDate.getDate()
	const month = typedDate.getMonth() + 1
	const year = typedDate.getFullYear()
	return `${day.toString().padStart(2, '0')}/${month
		.toString()
		.padStart(2, '0')}/${year}`
}

export const getMonthAndYear = (date: string) => {
	let mappedDate = new Date(date).toDateString().slice(4)
	mappedDate = `${mappedDate.slice(0, 3)} ${mappedDate.slice(-4)}`
	return mappedDate
}

export const convertDateToIsoString = (
	date: Date | null | undefined | string
) => {
	if (!date) {
		return undefined
	}
	if (typeof date === 'string') {
		return date
	}
	const dateTimestamp = date.getTime()
	if (Number.isNaN(dateTimestamp)) {
		return undefined
	}
	// Use local date components to construct a UTC midnight timestamp, so the
	// intended calendar day is preserved regardless of the user's timezone.
	return (
		new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
			.toISOString()
			// Removes the microseconds as the server expects only seconds.
			.replace(/\.\d*Z$/, 'Z')
	)
}

export const addYearsToIsoDate = (isoDate: string, years: number): string => {
	const date = new Date(isoDate)
	return new Date(
		Date.UTC(
			date.getUTCFullYear() + years,
			date.getUTCMonth(),
			date.getUTCDate()
		)
	)
		.toISOString()
		.replace(/\.\d*Z$/, 'Z')
}

// Helper function to create year array from startYear to endYear (inclusive)
export const createYearArray = (
	endYear: number,
	startYear = 2010
): number[] => {
	const length = endYear - startYear + 1
	return Array.from({ length }, (_, index) => endYear - index)
}
